import React, {antdUI, $tools, useRef} from 'react';
import './priceFilter.scss'
import { useI18n } from '@/i18n';
function PriceFilter(props){
  const { t } = useI18n();

  const {priceFilter, minPrice, setMinPrice, maxPrice, setMaxPrice} = props

  const { checkInputValNumber,debounce} = $tools;
  const delayPriceFilter = useRef(debounce(priceFilter,1000,true)).current

  return(
    <div className='price-filter'>
      <antdUI.Input
        prefix="￥"
        size={"small"}
        value={minPrice}
        allowClear
        placeholder={ t('价格') }
        onChange={(_) => setMinPrice(checkInputValNumber(_.target.value))}
        style={{ width: "90px" }}
      ></antdUI.Input>
      <span style={{ color: "white" }}>—</span>
      <antdUI.Input
        prefix="￥"
        size={"small"}
        value={maxPrice}
        allowClear
        placeholder={ t('价格') }
        onChange={(_) => setMaxPrice(checkInputValNumber(_.target.value))}
        style={{ width: "90px" }}
      ></antdUI.Input>

      <antdUI.Button
        size={"small"}
        onClick={()=>delayPriceFilter(minPrice,maxPrice)}
        className="price-filter-btn"
        // size={"small"}
      >
        { t('过滤') }
      </antdUI.Button>
    </div>


  )
}



export default PriceFilter
